import React from 'react'
import { useTranslation } from 'react-i18next'
import { Radio } from '@node-space/ui-components'
import { useOnceOffExportContext } from 'hooks/context/useOnceOffExportContext'
import { ReportType, ReportTypes } from 'types/transactionsExport'
import { reportTypeRadioOptions } from '../constants/exportOptions'

export const ReportTypeSelector = () => {
  const { t } = useTranslation()
  const { formValues, setValue } = useOnceOffExportContext()

  const reportTypeOptions = reportTypeRadioOptions()

  return (
    <>
      <p className="ml-4 text-label text-foreground-prominent mb-2">{t('exports.reportType')}</p>
      <Radio
        onChange={value => {
          setValue('reportType', value as ReportType)
          if (value === ReportTypes.BALANCE) {
            setValue('selectedExportFormat', 'csv')
          }
        }}
        options={reportTypeOptions}
        value={formValues.reportType}
        border={false}
        horizontal
      />
    </>
  )
}
